import { theme } from '../styles/theme';

interface EmbedOptions {
  title?: string;
  width?: string;
  maxWidth?: string;
  aspectRatio?: string;
  borderColor?: string;
  allowFullScreen?: boolean;
}

const defaultEmbedOptions: EmbedOptions = {
  title: 'Kubit Embed',
  width: '100%',
  maxWidth: '1280px',
  aspectRatio: '1280/720',
  borderColor: theme.colors.border,
  allowFullScreen: true,
};

/**
 * Generates an iframe embed code with customizable options
 * @param src - The source URL for the iframe
 * @param options - Optional configuration for the iframe
 * @returns A formatted iframe HTML string
 */
export const generateEmbedCode = (
  src: string,
  options: EmbedOptions = {},
): string => {
  const { title, width, maxWidth, aspectRatio, borderColor, allowFullScreen } =
    { ...defaultEmbedOptions, ...options };

  const style = [
    `border: 1px solid ${borderColor}`,
    `width: ${width}`,
    `aspect-ratio: ${aspectRatio}`,
    `max-width: ${maxWidth}`,
  ].join('; ');

  return `<iframe 
  style="${style}"
  src="${src}"
  title="${title}"
  ${allowFullScreen ? 'allowfullscreen' : ''}
  ></iframe>`;
};
